/* eslint-disable import/no-named-as-default-member */
import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from 'locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    ns: ['gcrm'],
    defaultNS: 'gcrm',
    nsSeparator: ':',
    resources: {
      en: en,
    },
    lng: 'en',
  });

export { default as i18n } from 'i18next';
